// Completion time entry for the event tracker. Pure functions only.

import { toLocalDate } from './trackerPacing'

// Element's el-time-picker parses typed or pasted text against the time-only
// display format, and its parser fills the missing date with January 1 of the
// current year. Keep the hour and minute from the picker and take the date
// from the objective's previous value, or today when it had none.
//
// QGP-2531 fixed this by moving every value to today; OTC-2489 removed that
// so a tracker submitted after midnight keeps the solve on its real day, which
// brought the January 1 dates back (OTC-3058). Anchoring to the previous value
// covers both. The previous value may be a Date or, after a draft save, a
// "YYYY-MM-DD HH:mm" string (toLocalDate parses it without new Date(string),
// which Safari rejects).
export function mergePickedSolveTime(previous, picked, now = new Date()) {
  if (!(picked instanceof Date) || isNaN(picked.getTime())) {
    return picked
  }
  const base = toLocalDate(previous) || now
  return new Date(
    base.getFullYear(), base.getMonth(), base.getDate(),
    picked.getHours(), picked.getMinutes(), picked.getSeconds()
  )
}
